import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

/* global REST_API_URL */
/* global AUTH_TOKEN_KEY */
/* global AUTH_REFRESH_TOKEN_KEY */

export function getAuthorization(token) {
  return `Bearer ${token}`
}

export function getOauthUrl() {
  return `${REST_API_URL}/oauth/token`
}

function getParamsForNewTokensReq() {
  const refreshToken = localStorage.getItem(AUTH_REFRESH_TOKEN_KEY)

  const params = new URLSearchParams()
  params.append('grant_type', AUTH_REFRESH_TOKEN_KEY)

  if (refreshToken) {
    params.append(AUTH_REFRESH_TOKEN_KEY, refreshToken)
  }

  return params
}

function getHeadersForNewTokensReq() {
  const accessToken = localStorage.getItem(AUTH_TOKEN_KEY)

  return {
    Authorization: getAuthorization(accessToken),
    'x-request-id': uuidv4(),
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

export async function getNewTokens() {
  const url = getOauthUrl()
  const params = getParamsForNewTokensReq()
  const headers = getHeadersForNewTokensReq()

  const { data: newTokens } = await axios.post(url, params, { headers })

  return newTokens
}

export function updateLocalTokens(newTokens) {
  localStorage.setItem(AUTH_TOKEN_KEY, newTokens.access_token)
  localStorage.setItem(AUTH_REFRESH_TOKEN_KEY, newTokens.refresh_token)
}
